'use strict';

function biggerlinkFunction(g) {
  var $link = $('.is-link');

  function simulateBiggerLink() {
    $link.each(function(index) {
      if (0 == $(this).find('a').length) {
          $(this).removeClass('is-link');
      }
    });

    $link.click(function(event) {
      event.preventDefault();
      var link = $(this).find('a:first').attr('href');
      if (link !== undefined) {
        if(event.metaKey) {
          open(link, '_blank');
        } else {
          location.href = link;
        }
      }
    });
  }

  function init() {
    simulateBiggerLink();
  }

  init();
}
